import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background-50/80 backdrop-blur-md border-b border-background-200/60">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <span className="font-heading text-2xl font-semibold text-foreground-900 tracking-tight">
              yoybuy
            </span>
          </Link>

          <div className="flex items-center gap-4">
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-2 px-5 py-2.5 bg-background-50 border border-background-300 rounded-full text-sm text-foreground-700 hover:border-background-400 transition-colors cursor-pointer whitespace-nowrap font-body"
              >
                <span>Выберите категорию</span>
                {dropdownOpen ? (
                  <i className="ri-arrow-up-s-line text-foreground-500 w-4 h-4 flex items-center justify-center"></i>
                ) : (
                  <i className="ri-arrow-down-s-line text-foreground-500 w-4 h-4 flex items-center justify-center"></i>
                )}
              </button>

              {dropdownOpen && (
                <div className="absolute top-full mt-2 left-0 w-64 bg-background-50 border border-background-200/80 rounded-2xl overflow-hidden z-50 max-h-80 overflow-y-auto">
                  {categories.map((cat) => (
                    <a
                      key={cat.slug}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 transition-colors font-body whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hidden md:flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shopping-bag-3-line w-4 h-4 flex items-center justify-center"></i>
              <span>BUY IT NOW</span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}